'use strict';

var poser = require('poser');
var Dominus = poser.Array();

module.exports = Dominus;
